module.exports = __webpack_public_path__ + "img/35.4.NH3-N.2849dcd9.png";